function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.6658 12.9997V11.6665C11.6658 10.9593 11.3849 10.281 10.8849 9.78099C10.3848 9.28093 9.70657 9 8.99938 9H3.66646C2.95927 9 2.28105 9.28093 1.78099 9.78099C1.28093 10.281 1 10.9593 1 11.6665V12.9997",
  stroke: "#EB6324",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.33248 6.33292C7.80512 6.33292 8.99894 5.1391 8.99894 3.66646C8.99894 2.19381 7.80512 1 6.33248 1C4.85983 1 3.66602 2.19381 3.66602 3.66646C3.66602 5.1391 4.85983 6.33292 6.33248 6.33292Z",
  stroke: "#EB6324",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgColoredUser = function SvgColoredUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgColoredUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/colored-user.f7a31825.svg";
export { ForwardRef as ReactComponent };